import React, { useState } from 'react'
import { Portal } from 'react-portal'
import Calendar from '../../Calendar/Calendar'
import { Subscribe } from 'unstated'
import CalendarStore from '../../Calendar/Store/CalendarStore'
import Button from '../../../Components/Buttons/Button'
import { notify } from '../../../Helpers/Notifications'
import Success from '../../../Components/Success/Success'
import { scheduleMakeUpClass } from '../../../API/Course'
import date from 'date-and-time'

const Reschedule = ({
  livDemyID,
  close,
  info: { classId, courseRegistrationId },
  remaining,
  total,
  startTime,
}) => {
  const [submitting, setSubmitting] = useState(false)
  const [success, setSuccess] = useState(false)

  return (
    <Portal>
      {success ? (
        <Success
          heading={`The class has been rescheduled`}
          subText={`You have ${remaining}/${total} reschedules remaining.`}
          secondary={{
            name: 'Back',
            action: () => {
              close()
              window.location.reload()
            },
          }}
          primary={{
            name: 'Go to home',
            route: '/',
          }}
        />
      ) : (
        <Subscribe to={[CalendarStore]}>
          {({ getPickedSlots }) => (
            <div className='reschedule'>
              <div className='controls'>
                <Button
                  onClick={async () => {
                    const slot = getPickedSlots()[0]
                    if (!slot) {
                      notify('error', `Pick the new timings for the class.`)
                      return
                    }
                    setSubmitting(true)

                    const startTime = slot.startTime

                    const success = await scheduleMakeUpClass({
                      crId: courseRegistrationId,
                      classId: classId,
                      startTime,
                    })

                    setSuccess(success)
                  }}
                  name={'submit'}
                  type={'primary'}
                  disabled={submitting}
                />
                <Button
                  onClick={() => close()}
                  name={'Cancel'}
                  type={'secondary'}
                  disabled={submitting}
                />
              </div>

              <Calendar
                livDemyID={livDemyID}
                slots={1}
                courseInfo={{ name: '' }}
                topBarMessage={`Pick new timings for the class originally on ${date
                  .format(new Date(startTime), `DD MMMM, hh:mm A`)
                  .split('.')
                  .join('')}:`}
              />
            </div>
          )}
        </Subscribe>
      )}
    </Portal>
  )
}

export default Reschedule
